import { render } from "./GenderStep.vue?vue&type=template&id=18ef47d9&ts=true"
import script from "./GenderStep.vue?vue&type=script&lang=ts"
export * from "./GenderStep.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__